import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";

export default function ActivityLog() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/activity").then((r) => setItems(r.data.items)); }, []);

  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs tracking-[0.3em] uppercase text-orange-400 font-bold">Audit</div>
        <h1 className="font-display text-4xl sm:text-5xl font-black text-white tracking-tight">ACTIVITY LOG</h1>
      </div>
      <div className="bg-[#131D33] border border-slate-800 rounded-2xl divide-y divide-slate-800">
        {items.length === 0 && <div className="p-8 text-center text-slate-500">No admin activity yet.</div>}
        {items.map((r) => (
          <div key={r.id} className="p-4">
            <div className="flex justify-between flex-wrap gap-2">
              <div className="text-orange-300 font-bold">{r.action}</div>
              <div className="text-slate-400 text-sm">{new Date(r.at).toLocaleString()}</div>
            </div>
            <div className="text-xs text-slate-500 mt-1">
              by {r.actor_email}
              {r.ticket_id && <> · <Link to={`/tickets/${r.ticket_id}`} className="text-teal-400 hover:underline">ticket</Link></>}
            </div>
            {(r.previous || r.new) && (
              <div className="mt-2 text-xs text-slate-400 font-mono-fb bg-[#0B1120] rounded p-2 border border-slate-800 overflow-x-auto">
                {r.previous ? `prev: ${JSON.stringify(r.previous)}\n` : ""}
                {r.new ? `new: ${JSON.stringify(r.new)}` : ""}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
